import materialRoutes from 'app/views/material-kit/MaterialRoutes';
import formsRoutes from 'app/views/forms/FormsRoutes';
import NotFound from 'app/views/sessions/NotFound';
import Home from 'components/Home';

export const AllPages = () => {
  const all_routes = [
    {
      path: '/',
      element: <Home />,
      children: [...materialRoutes, ...formsRoutes],
    },
    // {
    //   path: '*',
    //   element: <NotFound />,
    // },
  ];

  return all_routes;
};
